import React, { FC, useEffect } from "react";
import { Route, Routes } from "react-router-dom";

import { pages } from "@/root/consts";
import { useAppDispatch } from "@/hooks/redux";
import useInitSocketConnection from "@/hooks/useInitSocketConnection";
import useListeners from "@/hooks/useListeners";
import { closeServerSocketConnection } from "@/store/reducers/serverConnection/asyncActionCreators";
import {
  AdminPage,
  ErrorPage,
  GraphicPage,
  ReportPage,
  SettingsPage,
} from "@/pages";

const Main: FC = () => {
  const dispatch = useAppDispatch();

  useInitSocketConnection();
  useListeners();

  useEffect(() => {
    return () => {
      dispatch(closeServerSocketConnection());
    };
  }, [dispatch]);

  return (
    <Routes>
      <Route path={pages.admin.path} element={<AdminPage />} />
      <Route path={pages.graphic.path} element={<GraphicPage />} />
      <Route path={pages.report.path} element={<ReportPage />} />
      <Route path={pages.settings.path} element={<SettingsPage />} />
      <Route path="*" element={<ErrorPage />} />
    </Routes>
  );
};

export default Main;
